// extracted by mini-css-extract-plugin
module.exports = {"table":"TableViewer_table__u2Sbw"};